import styled from '@emotion/styled';
import { MobileBreakpoint } from '@utils/consts/breakpoints.consts';

export const TypWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  // height: 80vh;
  /* overflow-y: scroll; */
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const ThankYouMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  align-self: stretch;
  padding-bottom: 1rem;
`;

export const SubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
`;

export const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60%;
  @media screen and (max-width: ${MobileBreakpoint}px) {
    width: 80%;
  }
`;

export const AppointmentPageCard = styled.div<{ variant: 'red' | 'green' }>`
  display: flex;
  display: flex;
  padding: 0.5rem 1rem;
  align-items: center;
  gap: 1rem;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 0.5rem;
  background-color: ${props =>
    props.variant === 'red' ? 'rgba(255, 175, 199, 0.40)' : '#E2FCE5'};
  border: 1px solid
    ${props =>
      props.variant === 'red' ? '#FFAFC7' : 'rgba(35, 174, 49, 0.20)'};
`;

export const CardTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
`;

export const ErrorWrapper = styled.div<{ isDesktop: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  width: ${props => (props.isDesktop ? '75%' : '100%')};
  align-self: center;
  padding: 2.5rem 1.5rem;
  gap: 1rem;
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0px -2px 8px -1px #1b242c14;
`;

export const IconTitleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
`;

export const ButtonsWrapper = styled.div<{ allFailed: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.allFailed ? 'center' : 'space-between')};
  gap: 1rem;

  @media screen and (max-width: 576px) {
    flex-direction: column;
  }
`;
